import React from "react";
import { cn } from "@/utils/helpers";
import SvgIcon, { SvgIconProps } from "./SvgIcon";
import styles from "../Svg.module.css";

export default function SvgIconInfo({
	className,
	...props
} : SvgIconProps) {
	return (
		<SvgIcon
			className={cn(styles.SvgIconInfo, className)}
			{...props}
		>
			<path d="M61.656 28.568C61.656 32.096 58.56 34.616 55.104 34.616C52.224 34.616 50.064 32.6 50.064 29.72C50.064 26.192 53.088 23.528 56.544 23.528C59.496 23.528 61.656 25.688 61.656 28.568ZM58.92 39.8L55.68 65.936C55.536 66.872 56.04 67.232 56.832 67.232C57.336 67.232 57.696 67.16 57.984 67.088L57.48 73.928C56.976 74.072 55.464 74.504 52.728 74.504C47.76 74.504 46.104 71.912 46.608 67.952L50.064 40.016L58.92 39.8Z" />
			<path d="M96 50C96 24.5949 75.4051 4 50 4C24.5949 4 4 24.5949 4 50C4 75.4051 24.5949 96 50 96C75.4051 96 96 75.4051 96 50ZM100 50C100 77.6142 77.6142 100 50 100C22.3858 100 0 77.6142 0 50C0 22.3858 22.3858 0 50 0C77.6142 0 100 22.3858 100 50Z" />
		</SvgIcon>
	)
}
